/**
 * Calculate the difference in nights between two dates
 * @param {string|Date} start - Start date
 * @param {string|Date} end - End date
 * @returns {number} Number of nights
 */
export function dateDiffInNights(start, end) {
  const msInDay = 24 * 60 * 60 * 1000;
  const startDate = new Date(start);
  const endDate = new Date(end);

  if (!start || !end || isNaN(startDate) || isNaN(endDate)) {
    return 0;
  }
  
  const diff = Math.floor((endDate - startDate) / msInDay);
  return diff > 0 ? diff : 0;
}

export default dateDiffInNights;


